export async function blobToBase64(blobUrl) {
  // #ifdef H5
  const response = await fetch(blobUrl);
  const blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result;
      resolve(base64String);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
  // #endif
}

export function base64ToBlob(code) {
  // #ifdef H5
  let parts = code.split(";base64,");
  let contentType = parts[0].split(":")[1];
  let raw = window.atob(parts[1]);
  let rawLength = raw.length;
  let uInt8Array = new Uint8Array(rawLength);
  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  return new window.Blob([uInt8Array], { type: contentType });
  // #endif
}

export function appSaveImgFile(base64, downloadName) {
  const bitmap = new plus.nativeObj.Bitmap("test");
  bitmap.loadBase64Data(
    base64,
    function () {
      const url = "_doc/" + downloadName + ".png"; // url为时间戳命名方式
      bitmap.save(
        url,
        {
          overwrite: true, // 是否覆盖
          // quality: 'quality'  // 图片清晰度
        },
        (i) => {
          plus.gallery.save(
            i.target,
            function () {
              uni.showToast({
                title: "图片保存至相册成功",
                icon: "none",
              });
              bitmap.clear();
            },
            function (e) {
              uni.showToast({
                title: "图片保存至相册失败:" + JSON.stringify(e),
                icon: "none",
              });
              bitmap.clear();
            }
          );
        },
        (e) => {
          uni.showToast({
            title: "图片保存失败1:" + JSON.stringify(e),
            icon: "none",
          });
          bitmap.clear();
        }
      );
    },
    (e) => {
      uni.showToast({
        title: "图片保存失败2:" + JSON.stringify(e),
        icon: "none",
      });
      bitmap.clear();
    }
  );
}

export function getFileSuffixByType(fileType) {
  let extname = "";
  // 假设tempFiles数组中有文件对象，并且每个文件对象都有一个type属性，指明文件的MIME类型。
  switch (fileType) {
    case "application/pdf":
      extname = "pdf";
      break;
    case "application/msword":
      extname = "doc";
      break;
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      extname = "docx";
      break;
    case "image/png":
      extname = "png";
      break;
    case "image/jpeg":
      extname = "jpg";
      break;
    case "image/gif":
      extname = "gif";
      break;
    case "text/plain":
      extname = "txt";
      break;
    case "text/html":
      extname = "html";
      break;
    case "application/zip":
      extname = "zip";
      break;
    case "application/x-rar-compressed":
      extname = "rar";
      break;
    case "video/mp4":
      extname = "mp4";
      break;
    case "audio/mpeg":
      extname = "mp3";
      break;
    // ... 可以继续添加更多的文件类型匹配
    default:
      extname = ""; // 如果类型未知，可以设置为空字符串或者进行其他操作
      break;
  }
  return extname;
}